var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideTree',{ref:"refSideTree",attrs:{"width":_vm.width,"load":_vm.getGroupList,"pageableLoad":_vm.getFileLogList,"default-props":_vm.defaultProps,"default-current-node":"first"},on:{"download":_vm.handleGroupDownload,"delete":_vm.handleGroupDelete,"change":_vm.handleGroupChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }